// import React, { useState, useEffect } from "react";
// import { Container } from "reactstrap";
// import CourieListView from "./CourieListView";
// import Section from "./SectionList";
// import { getCouriers } from "../../../api/courier/courierApi";

// const CourierList = () => {
//   const [couriers, setAllCouriers] = useState([]);
//   document.title = "Courier List | StarMarket";

//   useEffect(() => {
//     const fetchCouriers = async () => {
//       try {
//         const response = await getCouriers();
//         console.log("Fetched Couriers:", response.data.data);
//         setAllCouriers(response.data.data);
//       } catch (error) {
//         console.error("Error fetching couriers:", error.message);
//       }
//     };

//     fetchCouriers();
//   }, []);

//   return (
//     <React.Fragment>
//       <Section />
//       <section className="section">
//         <Container>
//           <CourieListView couriers={couriers} />
//         </Container>
//       </section>
//     </React.Fragment>
//   );
// };

// export default CourierList;

import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Spinner,
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CourieList.css'; // Update CSS file name if necessary
import CourierOffCanvasComponent from '../../Stocks/CourierOffCanvasComponent';
import { getCouriers } from '../../../api/courier/courierApi';

const CourierList = () => {
  const [show, setShow] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [courier, setCourier] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchAllCourier = async () => {
    setLoading(true);
    try {
      const response = await getCouriers();
      const profiles = response.data.data || [];
      console.log('API response:', response);
      if (!Array.isArray(profiles)) {
        console.error('Expected profiles to be an array, got:', profiles);
        setCourier([]);
      } else {
        setCourier(profiles);
      }
    } catch (error) {
      console.error('Error fetching profiles:', error);
      setCourier([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCourier();
  }, []);

  useEffect(() => {
    console.log('Plants state:', courier);
  }, [courier]);

  const handlePlantClick = (id) => {
    setSelectedOwner(id);
    setShow(true);
  };

  const toggleModal = () => {
    setShow(!show);
    if (show) setSelectedOwner(null);
  };

  const filteredCourier = Array.isArray(courier)
    ? courier.filter((courier) =>
        courier.companyName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <div style={{ minHeight: '100%', marginTop: '100px', padding: '30px' }}>
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">Couriers</h4>
          <div className="d-flex align-items-center">
            <InputGroup style={{ width: '200px' }}>
              <Input
                placeholder="Search by Company Name"
                className="rounded2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </div>
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <Spinner color="primary" />
          </div>
        ) : filteredCourier.length === 0 ? (
          <div
            className="text-center"
            style={{
              minHeight: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <h5>No processing plants found.</h5>
          </div>
        ) : (
          <Row>
            {filteredCourier.map((plant, index) => (
              <Col
                xs="12"
                sm="6"
                md="4"
                lg="3"
                key={plant._id || index}
                className="mb-4"
              >
                <Card>
                  <CardBody className="text-left">
                    <div className="d-flex">
                      <img
                        style={{ margin: '0px 18px' }}
                        src={
                          plant.profileImage || 'https://via.placeholder.com/80'
                        }
                        className="avatar-placeholder mb-3"
                        alt="Owner"
                      />
                      <div style={{ marginTop: '5px' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '24px',
                            cursor: 'pointer',
                          }}
                          className="mb-1"
                          onClick={() => handlePlantClick(plant._id)}
                        >
                          {plant.companyName}
                        </span>
                        <div className="d-flex justify-content-left align-items-center mb-2">
                          <span
                            style={{
                              position: 'relative',
                              fontSize: '24px',
                              marginRight: '8px',
                              bottom: '2px',
                            }}
                            className="star-icon mr-1"
                          >
                            ★
                          </span>
                          <span style={{ fontSize: '18px' }}>
                            {plant.rating || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <style jsx>{`
          .avatar-placeholder {
            width: 80px;
            height: 80px;
            background-color: #e0e0e0;
            border-radius: 50%;
            object-fit: cover;
          }
          .star-icon {
            color: #ffd700;
            font-size: 1.2rem;
          }
          .card {
            transition: transform 0.2s;
          }
          .card:hover {
            transform: translateY(-5px);
          }
        `}</style>
        <CourierOffCanvasComponent
          isOpen={show}
          onToggle={toggleModal}
          courierId={selectedOwner}
        />
      </Container>
    </div>
  );
};

export default CourierList;
